// @flow

// The output of a listener is never used
type Listener<V> = (value: V) => mixed;

/**
 * A publish-subscribe channel with only a single listener at any time
 */
export class UnicastChannel<V> {
  listener: ?Listener<V>;

  /**
   * Subscribe listener to channel. Throw away previous listener, if any.
   */
  subscribe: (Listener<V>) => void = listener => {
    this.listener = listener;
  };

  /**
   * Publish a value to the current listener.
   */
  publish: V => void = value => {
    this.listener && this.listener(value);
  };
}

export default function createUnicastChannel<V>(): UnicastChannel<V> {
  return new UnicastChannel();
}
